// extracted by mini-css-extract-plugin
export default {"error":"NonIdealState_error__+WP9Y","image":"NonIdealState_image__OHipV","title":"NonIdealState_title__x1zHj","description":"NonIdealState_description__pbYaR"};